import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import APP_ROUTES from "src/routes/routes";
import { getProjectInstanceUploadFileHistories } from "src/services/project-instances";

const useGetInstanceUploadFileHistories = (id, params) => {
  const { filesHistoryPage = 1, limit = 9999999, q } = params || {};
  const navigate = usePatchedNavigate();

  const { data, isError, error, refetch, isFetching } = useQuery({
    queryKey: ["getInstanceUploadFileHistories", id, filesHistoryPage],
    queryFn: () => {
      const params = { page: filesHistoryPage, limit };
      if (q) {
        params.q = q;
      }
      return getProjectInstanceUploadFileHistories(id, params);
    },
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    refetch,
    isError,
    error,
    isFetching,
  };
};

export default useGetInstanceUploadFileHistories;
